import ShiftsSummaryInformationBox from '@web/labor/ShiftsSummaryInformationBox/ShiftsSummaryInformationBox';

export default {
  ReactComponent: ShiftsSummaryInformationBox,
  bindings: {
    summary: '<',
    openAddShiftModal: '&',
  },
};
